let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hpN5y")).then(() => parcelRequire('jhEjP'));